export default function StatusSwitch({ value, onChange }) {
    return (
      <div className="flex items-center gap-3">
        <div
          onClick={() => onChange(!value)}
          className={`relative inline-flex h-6 w-10 cursor-pointer rounded-full transition-colors duration-300
            ${value ? "bg-[#213e39]" : "bg-gray-300"}`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-300
              ${value ? "-translate-x-5" : "translate-x-0"}`}
          />
        </div>
  
        <span 
          className={`text-sm font-medium transition-colors duration-300
          ${value ? "text-gray-700" : "text-gray-400"}`}>
          طرح اختصاصی
        </span>
      </div>
    );
  }
  